class KeyFlowParamVO {
  getParam() {
    const param: any = {};
    for (const key in this) {
      const value = this[key];

      if (value === null || value === undefined) {
        continue;
      }

      if (value instanceof Array && value.length === 0) {
        continue;
      }

      param[key] = value;
    }
    return param;
  }
}

export default KeyFlowParamVO;
